import i18n from "../../plugins/I18nPlugin";

export function isNumberRule(
  message = "components.partner.PartnerReportDetail.SendToKsrDialog.isNumberRule"
): (value: any) => boolean | string {
  return (value) => !isNaN(value) || String(i18n.tc(message));
}
